import { Match, MatchStat } from "@app/core/match/domain/model/match";
import { DateMapper } from "@app/core/shared/data/network/date.mapper";

const matchStatMapper = {
  "payment-missing": MatchStat.PAYMENT_MISSING,
  "match-ready-to-play": MatchStat.MATCH_READY_TO_PLAY,
  available: MatchStat.AVAILABLE,
  "player-identification-missing": MatchStat.PLAYER_IDENTIFICATION_MISSING,
  "in-progress": MatchStat.IN_PROGRESS,
  "others-payment-missing": MatchStat.OTHERS_PAYMENT_MISSING,
};

export class MatchMapper {
  static deserialize(response: any): Match {
    const victory =
      response.victory === 1
        ? "victory"
        : response.victory === 0
          ? "defeat"
          : null;
    return {
      code: response.code,
      date: DateMapper.deserialize(response.date),
      club: response.club,
      curt: response.pista,
      matchStat:
        matchStatMapper[response.match_stat as keyof typeof matchStatMapper],
      victory: victory,
      payment_done: response.payment_done,
      reservationId: response.reservation_id ?? null,
      shareable: response.shareable,
      players: response.players,
    };
  }
}
